<template>
  <div class="instInputWrap">
    <div class="instInputPosition" v-bind:class="{issetError:fieldStatus.ShowError && fieldStatus.code > 0}">
      <input :value="visibleValue" autocomplete="off" v-on:focus="fuckThisFocus">
      <select v-model.trim="value" :id="'f'+fieldName">
        <option :key="index"
                :value="option.value"
                v-for="(option,index) in getRefValue(fieldName)">
          {{option.name}}
        </option>
      </select>
      <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.18.188a.706.706 0 00-.5-.182.73.73 0 00-.489.209.663.663 0 00-.19.476.64.64 0 00.218.466l6.296 5.66c.13.118.302.183.481.183s.35-.065.48-.182l6.298-5.661A.668.668 0 0014 .69a.637.637 0 00-.19-.481.702.702 0 00-.494-.209.73.73 0 00-.503.188l-5.817 5.23L1.18.188z" fill="#8A919C"/></svg>
      <label :for="'f'+fieldName" v-bind:class="{active:value.length > 0 || inFocus}">{{ item.label }}</label>
    </div>
    <p class="instErrMsg" v-if="fieldStatus.ShowError">{{ fieldStatus.msg }}</p>
  </div>
</template>

<script>
import DataForInput from '@/store/Form/longFormOptions';
import {mapGetters, mapState} from "vuex";

export default {
  name: "instSelect",
  data: function () {
    return {
      inFocus: false,
      item: DataForInput[this.fieldName],
    }
  },
  props: {
    fieldName: {
      type: String,
      default: ''
    },
  },
  methods:{
    fuckThisFocus($event){
      $event.target.blur();
    }
  },
  computed: {
    ...mapState({
      // statusVuex:state => state.Form.workData[this.fieldName] //так не взлетело
      statusVuex: state => state.Form.workData,
      valueVuex: state => state.Form.sendData,
    }),
    ...mapGetters(['getRefValue']),
    fieldStatus() {
      return this.statusVuex[this.fieldName];
    },
    visibleValue() {
      const finResult = this.getRefValue(this.fieldName).find((el)=>el.value === this.value );
      console.log(finResult)
      return finResult?.name !== undefined ? finResult.name : '';
    },
    value: {
      get() {
        return this.valueVuex[this.fieldName];
      },
      set(value) {
        this.$store.dispatch('saveSendData', {
          target: this.fieldName,
          value: value
        });
      }
    },
  }
}
</script>

<style scoped>
input{pointer-events: none}
select{position: absolute;top:0;left:0;width: 100%;height: 100%;opacity: 0;}
</style>